import {
  getPlayerScoreboardName,
  scoreboardNameFromPlayer,
} from "./playerDisplayName";

export const getDisplayName = (name) => {
  if (!name) return "Unknown Player";

  if (typeof name === "string") {
    return getPlayerScoreboardName({ name }) || "Unknown Player";
  }

  if (name.playerId || name.bio || name.bioData || name.nickName) {
    return scoreboardNameFromPlayer(name);
  }

  if (name.birthName) {
    return (
      getPlayerScoreboardName({
        birthName: name.birthName,
        nickName: name.nickName,
        name: name.name,
      }) || name.birthName
    );
  }

  return String(name);
};

/** Last name (or family name) for compact labels — handles Jr./Sr./II suffixes. */
export const getLastName = (name) => {
  const display = getDisplayName(name);
  const parts = display.trim().split(/\s+/);
  if (parts.length <= 1) return display;

  const suffixes = new Set(["Jr.", "Jr", "Sr.", "Sr", "II", "III", "IV"]);
  const last = parts[parts.length - 1];
  if (suffixes.has(last) && parts.length >= 2) {
    return parts[parts.length - 2];
  }
  return last;
};

export const formatPlayerName = (player) =>
  scoreboardNameFromPlayer(player);
